import React from 'react';
import { Input } from './ui/input';
import { Search } from 'lucide-react';

export default function TableSearch({ value, onChange, placeholder = 'Search…', stats, className = '', testId = 'table-search' }) {
  return (
    <div className={`flex items-center gap-3 mb-4 ${className}`}>
      <div className="relative flex-1 max-w-md">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#787872] pointer-events-none" />
        <Input
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-9 pl-9 rounded-sm"
          data-testid={testId}
        />
      </div>
      {stats && (
        <div className="text-[12px] text-[#575757] font-mono">{stats}</div>
      )}
    </div>
  );
}

// Simple row-matches-query helper
export const rowMatches = (obj, q) => {
  if (!q) return true;
  const needle = q.trim().toLowerCase();
  if (!needle) return true;
  for (const v of Object.values(obj)) {
    if (v === null || v === undefined) continue;
    if (Array.isArray(v)) {
      if (v.some((x) => String(x).toLowerCase().includes(needle))) return true;
    } else {
      if (String(v).toLowerCase().includes(needle)) return true;
    }
  }
  return false;
};
